import React from 'react';
import { Button } from 'reactstrap';

const Btn = (props) =>{
    return <Button disabled={props.attrBtn.disabled} {...props.attrBtn}>{props.children}</Button>;
};

export default Btn;